import axios from 'axios';
import { app_version } from './Utils';

export const serverUrl = `${process.env.REACT_APP_SERVER_URL || ''}`;

axios.defaults.baseURL = serverUrl + '/api';
axios.defaults.headers.post['Content-Type'] ='application/json';

const ArthaGateway = {
    validateLogin: async function(userName, password) {
        try {
            const payload = { userName, password };
            let response = await axios.post('user/validate', payload);
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::validateLogin ->"+ error);
            throw error;
        }
        return false;
    },
    getProductionPlants: async function() {
        try {
            let response = await axios.get('master/productionPlant');
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getProductionPlants ->" + error);
            throw error;
        }
        return undefined;
    },
    getOrders: async function(durationId: string, productionPlantId: number, status: number, partyId: number, pageNumber: number = 1, pageSize: number = 10) {
        try {
            const params = { durationId, productionPlantId, status, partyId, departmentId: 0, companyId: 0, pageNumber, pageSize, fields: "Id,VoucherNumber,Date,Status,ProductionPlantName,Party.Name as PartyName" };
            let response = await axios.get('/voucher/order', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },
    getSalesOrders: async function(durationId, fromDate, toDate, productionPlantId, status, orderNumber = ""){
        try {
            let param = { durationId, fromDate, toDate, productionPlantId, status, voucherNumber: orderNumber, fields:'Id,Date,VoucherNumber,Quantity,ProductName,PartyName,StyleName,Narration,Status,ProductId,SaleOrderItemId,PendingQuantity,PressedQuantity,PackedQuantity,ProductionPlantId,MasterImageUrl,StyleImageUrl,CustomImageUrl,ExtraInformation' };
            let url = `voucher/order/detailed`;
            let response = await axios.get(url, { params: param });
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getSalesOrders ->" + error);
            throw error;
        }
        return undefined;
    },
    getSalesOrder: async function(orderId: number) {
        try {
            let response = await axios.get('/voucher/order/' + orderId);
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getSalesOrder ->"+ error);
            throw error;
        }
        return undefined;
    },  
    confirmSalesOrder: async function(order, userId: number) {
        try {
            let response = await axios.post('voucher/order/confirm?userId=' + userId, order);
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::confirmSalesOrder ->" + error);
            throw error;
        }
        return undefined;
    },
    editSalesOrder: async function(order, userId: number) {
        try {
            let response = await axios.post('voucher/order?userId=' + userId, order);
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::editSalesOrder ->" + error);
            throw error;
        }
        return undefined;
    },
    cancelSalesOrder: async function(orderId: number, reason: string, userId: number) {
        try {
            const params = { id: orderId, comment: reason, userId };
            let response = await axios.get('/voucher/order/delete', { params });
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::deleteSalesOrder ->"+ error);
            throw error;
        }
    },
    updateOrderStatus: async function(orderId, status, userId: number) {
        try {
            const param = { id: orderId, status, userId };
            let response = await axios.get('voucher/order/changeStatus', { params: param });
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::updateOrderStatus ->" + error);
            throw error;
        }
        return false;
    },
    saveProduction: async function(production, userId: number) {
        try {
            let response = await axios.post('voucher/production?userId=' + userId, production);
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::saveProduction ->" + error);
            throw error;
        }
    },
    searchParty: async function(searchText: string) {
        try {
            const params = { name: searchText, pageSize: 25, fields: "Id,Name,GSTIN" };
            let response = await axios.get('master/party', { params });
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::searchPartys ->" + error);
            throw error;
        }
    }
}

export default ArthaGateway;